<template>
  <round :device="device">
    <div>
      <img :src="state" style="width: 60px"/>
    </div>
    <div slot="footer" class="footer">
      <div @click="changeWind('low')">
        <div>
          <img :src="icon.low" style="width: 55px"/>
        </div>
        <div>
          <span>低风</span>
        </div>
      </div>
      <div @click="changeWind('medium')">
        <div>
          <img :src="icon.medium" style="width: 55px"/>
        </div>
        <div>
          <span>中风</span>
        </div>
      </div>
      <div @click="changeWind('high')">
        <div>
          <img :src="icon.high" style="width: 55px"/>
        </div>
        <div>
          <span>高风</span>
        </div>
      </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import { Message } from 'element-ui'
import api from '../model/device'

export default {
  name: 'Fan',
  data () {
    return {}
  },
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    state () {
      if (this.device.state.state) {
        return require('../assets/images/device/fan/device_fan_e.png')
      } else {
        return require('../assets/images/device/fan/device_fan.png')
      }
    },
    icon () {
      let icon = {
        low: require('../assets/images/device/df.png'),
        medium: require('../assets/images/device/zf.png'),
        high: require('../assets/images/device/gf.png')
      }
      if (this.device.state.state && this.device.state.air === 1) {
        icon.low = require('../assets/images/device/df-k.png')
      } else if (this.device.state.state && this.device.state.air === 2) {
        icon.medium = require('../assets/images/device/zf-k.png')
      } else if (this.device.state.state && this.device.state.air === 3) {
        icon.high = require('../assets/images/device/gf-k.png')
      }
      return icon
    }
  },
  components: {
    Round
  },
  methods: {
    async changeWind (wind) {
      try {
        await api.singleControl(this.device, wind)
      } catch (e) {
        Message.error(e.message)
      }
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    > div > div {
      height: 55px;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
